import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
// import getAmazonLink from "../functions/getAmazonLink";
import { mainURL } from "../constants";

const ListItem = styled(Link)`
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  text-decoration: none;
  border-radius: 5px;

  transition: all 0.2s;
  &:hover {
    background-color: #eee;
  }
`;

const Thumbnail = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 5px;
  margin-right: 10px;
  object-fit: cover;
  object-position: center;

  transition: transform 0.2s;

  ${ListItem}:hover & {
    transform: scale(1.05);
  }

  @media screen and (min-width: 480px) {
    height: 70px;
    width: 125px;
    object-fit: fill;
    object-position: 50% 50%;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-size: 1em;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  color: black;
  margin-bottom: 0.1em;
`;

const Artist = styled.div`
  font-size: 0.875em;
  margin-bottom: 0.25em;
  color: black;
  text-decoration: none;
`;

const Subtitle = styled.div`
  font-size: 12px;
  width: 100%;
  display: flex;
  align-items: space-between;
  text-decoration: none;
  color: #555;
`;

// const Quiz = styled(Link)`
//   margin-left: 20px;
//   text-decoration: none;
//   font-size: 10px;
//   border: solid thin black;
//   background-color: black;
//   border-radius: 4px;
//   padding: 4px 8px;
//   color: white;
// `;

interface ListTileProps {
  title: Queries.Maybe<string> | undefined;
  subtitle: Queries.Maybe<string> | undefined;
  artists: Queries.Maybe<readonly Queries.Maybe<string>[]> | undefined;
  slug: Queries.Maybe<string> | undefined;
  youtubeVideoId: Queries.Maybe<string> | undefined;
  withDomain?: boolean;
  siteUrl?: string;
}

const SongListTile: React.FC<ListTileProps> = ({
  title,
  subtitle,
  artists,
  slug,
  youtubeVideoId,
  withDomain = false,
  siteUrl = "",
}) => {
  const thumbnailUrl = `https://i.ytimg.com/vi/${youtubeVideoId}/mqdefault.jpg`;
  // const amazonLink = getAmazonLink({ asin });
  const prePath = withDomain ? siteUrl : "";
  const artist = artists?.join(", ");

  return (
    <ListItem
      to={`${prePath}/songs/${slug}/`}
      itemScope
      itemType="https://schema.org/Article"
    >
      <Thumbnail src={thumbnailUrl} alt="" loading="lazy" />
      {youtubeVideoId && (
        <meta
          itemProp="image"
          content={`${mainURL}thumbnail/${youtubeVideoId}.jpg`}
        />
      )}
      <TextContainer>
        <Title>{title}</Title>
        {/* <Quiz to={`/quizzes/${slug}`}>Quiz</Quiz> */}
        <Artist>{artist}</Artist>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <meta itemProp="headline" content={`${title} - ${artist}`} />
      </TextContainer>
      <span
        itemScope
        itemType="https://schema.org/Organization"
        itemProp="author"
      >
        <meta itemProp="name" content="コード進行メモ倉庫" />
        <meta itemProp="url" content={mainURL} />
      </span>
    </ListItem>
  );
};

export default SongListTile;
